/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import gatewayConfigurations from './gateway-configurations.directive';
import GatewayConfigurationController from './gateway-configuration.controller';

export default angular.module('tektelic.configuration', [gatewayConfigurations])
    .controller('GatewayConfigurationController', GatewayConfigurationController)
    .name;



// WEBPACK FOOTER //
// ./src/app/configuration/index.js